module.exports = __webpack_public_path__ + "static/media/banner.0085e406.png";